kv.controller('ActivityBudgetVsActualFromExpenseReportDetailsCtrl', function ($uibModalInstance, params, $scope, $injector, $timeout) {
    let vm = this;

    // Ensure the params data is correctly passed
    vm.data = params.entity;
    vm.month = params.month;
    vm.practiceName = params.practiceName;

    // Modal is rendered
    vm.modal = $uibModalInstance;

    vm.cancel = function() {
        vm.modal.dismiss('cancel');
    };

    return vm;
});
